var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8726 17.9375L10.3204 11.3853C9.82213 11.8172 9.24117 12.1535 8.5775 12.3943C7.91383 12.6351 7.20761 12.7556 6.45885 12.7556C4.66241 12.7556 3.14204 12.1327 1.89772 10.8871C0.653408 9.64141 0.03125 8.13831 0.03125 6.37778C0.03125 4.61725 0.65408 3.11415 1.89974 1.86849C3.1454 0.62283 4.65265 0 6.42148 0C8.19032 0 9.69342 0.62283 10.9308 1.86849C12.1681 3.11415 12.7868 4.61849 12.7868 6.38152C12.7868 7.0932 12.6705 7.78122 12.438 8.44557C12.2055 9.10993 11.8567 9.73275 11.3917 10.3141L17.9688 16.8413L16.8726 17.9375ZM6.43394 11.2608C7.78341 11.2608 8.93045 10.7833 9.87508 9.82826C10.8197 8.87325 11.292 7.72309 11.292 6.37778C11.292 5.03247 10.8197 3.88231 9.87508 2.9273C8.93045 1.97229 7.78341 1.49479 6.43394 1.49479C5.07064 1.49479 3.91183 1.97229 2.9575 2.9273C2.0032 3.88231 1.52604 5.03247 1.52604 6.37778C1.52604 7.72309 2.0032 8.87325 2.9575 9.82826C3.91183 10.7833 5.07064 11.2608 6.43394 11.2608Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4d0b5652e98a814803350777101dcc46.svg";
export { ForwardRef as ReactComponent };